<template>
  <v-card class="my-4">
    <v-card-title class="card-title-variations"> Preços </v-card-title>
    <v-row class="px-8">
      <v-divider></v-divider>
    </v-row>
    <v-card-text class="card-price px-10">
      <v-row>
        <v-col cols="3">
          <product-store-price-input
            v-model="productForms.price1"
            :validation-error="validation.product.price1 && validation.product.price1.$error"
            :validation-message="priceError"
            label="Preço"
          />
        </v-col>
        <v-col cols="3">
          <product-store-price-input
            v-model="productForms.sales[getSalesIndex('preco_com_desconto')].price2"
            :validation-error="validation.product.sales && validation.product.sales.$each[getSalesIndex('preco_com_desconto')].price2.$error"
            :validation-message="priceDiscountError"
            label="Preço com desconto"
            messages="Produto em oferta, esse campo sobrescreve o “Preço”"
          />
        </v-col>
        <v-col v-if="getDiscountValue > 0" cols="2">
          <div class="pa-2 percentual-discount">
            <span class="percentual-discount_text">{{ getDiscountValue }}% de desconto</span>
          </div>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row class="mt-2">
        <v-col cols="12">
          <mf-toggle v-model="productForms.sales[getSalesIndex('preco_atacado')].active" class="pb-n10" label="Valor de atacado" hide-details />
          <p class="mt-3 texto-corrido">
            Ative essa opção para produtos com preço de atacado. Você poderá selecionar a quantidade mínima e o preço de atacado.
          </p>
        </v-col>
        <v-scroll-x-transition>
          <v-col v-if="productForms.sales[getSalesIndex('preco_atacado')].active" cols="3">
            <mf-number-input
              v-model="productForms.sales[getSalesIndex('preco_atacado')].minimumLimit"
              label="Quantidade"
              outlined
              hide-details
              dense
              :min="0"
              :error="validation.product.sales && validation.product.sales.$each[getSalesIndex('preco_atacado')].minimumLimit.$error"
              :error-messages="wholesaleError"
            />
          </v-col>
        </v-scroll-x-transition>
        <v-scroll-x-transition>
          <v-col v-if="productForms.sales[getSalesIndex('preco_atacado')].active" cols="3">
            <product-store-price-input
              v-model="productForms.sales[getSalesIndex('preco_atacado')].price2"
              :validation-error="validation.product.sales && validation.product.sales.$each[getSalesIndex('preco_atacado')].price2.$error"
              :validation-message="wholesalePriceError"
              label="Preço de atacado"
            />
          </v-col>
        </v-scroll-x-transition>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import ProductStorePriceInput from './ProductStorePriceInput.vue'
import { localeString } from '@/config/helpers.js'
export default {
  name: 'ProductStorePrice',
  components: {
    ProductStorePriceInput,
  },
  props: {
    isCreate: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      required: true,
    },
    validation: {
      type: Object,
      required: true,
    },
  },
  data: () => ({}),
  computed: {
    vMoney() {
      return { decimal: ',', thousands: '.', precision: 2, masked: false }
    },
    productForms: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    priceError() {
      if (this.validation.product.price1 && this.validation.product.price1.$error) return 'Campo obrigatório'
      return ''
    },
    priceDiscountError() {
      if (
        this.validation?.product?.sales?.$each[this.getSalesIndex('preco_com_desconto')]?.price2?.$error &&
        !this.validation?.product?.sales?.$each[this.getSalesIndex('preco_com_desconto')]?.price2?.isLessThanPrice
      ) {
        return 'Desconto deve ser menor que o preço'
      }
      if (
        this.validation?.product?.sales?.$each[this.getSalesIndex('preco_com_desconto')]?.price2?.$error &&
        !this.validation?.product?.sales?.$each[this.getSalesIndex('preco_com_desconto')]?.price2?.required
      ) {
        return 'Campo obrigatório'
      }
      return ''
    },
    wholesaleError() {
      if (this.validation.product.sales && this.validation.product.sales.$each[this.getSalesIndex('preco_atacado')].minimumLimit.$error)
        return 'Campo obrigatório'
      return ''
    },
    wholesalePriceError() {
      if (this.validation.product.sales && this.validation.product.sales.$each[this.getSalesIndex('preco_atacado')].price2.$error) {
        if (!this.validation.product.sales.$each[this.getSalesIndex('preco_atacado')].price2.isLessThanPrice) return 'Preço atacado deve ser menor que o preço'
        if (
          !this.validation.product.sales.$each[this.getSalesIndex('preco_atacado')].price2.required ||
          !this.validation.product.sales.$each[this.getSalesIndex('preco_atacado')].price2.isZero
        ) {
          return 'Campo obrigatório'
        }
      }
      return ''
    },
    getDiscountValue() {
      let localDiscount = 0
      let localPrice = 0

      if (typeof this.productForms.sales[this.getSalesIndex('preco_com_desconto')].price2 === 'string') {
        localDiscount = this.productForms.sales[this.getSalesIndex('preco_com_desconto')].price2.replace(/\./g, '').replace(',', '.')
      } else {
        localDiscount = this.productForms.sales[this.getSalesIndex('preco_com_desconto')].price2
      }

      if (typeof this.productForms.price1 === 'string') {
        localPrice = this.productForms.price1.replace(/\./g, '').replace(',', '.')
      } else {
        localPrice = this.productForms.price1
      }

      const result = 100 - (localDiscount * 100) / localPrice

      return result >= 0 && localDiscount > 0 ? result.toFixed(2) : 0
    },
  },
  methods: {
    addEans() {
      this.openDialog = true
    },
    formatValue(val) {
      return localeString(val, 2)
    },
    getSalesIndex(salesType) {
      const position = this.productForms.sales.findIndex((sale) => sale.typeEcommerce === salesType)
      return position
    },
  },
}
</script>

<style lang="scss">
.card-price {
  .v-text-field--filled > .v-input__control > .v-input__slot,
  .v-text-field--full-width > .v-input__control > .v-input__slot,
  .v-text-field--outlined > .v-input__control > .v-input__slot {
    min-height: 44px !important;
    height: 44px;
  }

  .v-text-field--outlined .v-label {
    top: 12px !important;
  }

  .v-text-field--enclosed .v-input__append-inner,
  .v-text-field--enclosed .v-input__append-outer,
  .v-text-field--enclosed .v-input__prepend-inner,
  .v-text-field--enclosed .v-input__prepend-outer,
  .v-text-field--full-width .v-input__append-inner,
  .v-text-field--full-width .v-input__append-outer,
  .v-text-field--full-width .v-input__prepend-inner,
  .v-text-field--full-width .v-input__prepend-outer {
    margin-top: 11px;
  }
  .percentual-discount {
    background-color: $marca-0-l90;
    border-radius: 4px;
    text-align: center;
    &_text {
      color: $marca-0-l30;
      font-weight: 600;
    }
  }
}
</style>
